
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class ConfirmTip extends Vue {
  @Prop({ default: "确认" }) private btnText!: string;
  @Prop({ default: "#525FFF" }) private btnColor!: string;

  visible = false;

  show() {
    this.visible = true;
  }

  close() {
    this.visible = false;
  }
}
